export const ADD_MULTIPLE = 'entities/location/ADD_MULTIPLE';
export const ADD = 'entities/location/ADD';
export const UPDATE = 'entities/location/UPDATE';
export const REMOVE = 'entities/location/REMOVE';
export const FETCH_ALL_LOCATIONS = 'entities/location/FETCH_ALL_LOCATIONS';
